<template>
  <header class="landing-page-header">
    <div style="display: flex; justify-content: center; align-items: center; gap: 30px">  
      <div class="logo-container" @click="this.$router.push('/')">
        <img src="@/assets/login/Landing_page_middle_search/Tree_landing_page.svg" alt="Tree Logo" loading="lazy" class="logo-image"/>
        <div class="logo-text">
          <h1 class="logo-title">My Doctors Portal</h1>
          <span class="logo-subtitle">Healthcare Without Boundaries</span>
        </div>
      </div>
      <nav style="display: flex" class="icons_div_s-01">
        <div @click="navigateBigFileShare()" v-tippy="{ content: 'Big File Share', placement: 'bottom' }">
          <img class="header-services-icon" src="../../assets/login/landingpageTopBar/bigFileTransfer.png" alt="bigFileTransfer" loading="lazy">
        </div>
        <div @click="this.$router.push('/blogs')" v-tippy="{ content: 'Blogs', placement: 'bottom' }">
          <img class="header-services-icon" src="../../assets/login/landingpageTopBar/Blog.png" alt="blog" loading="lazy" />
        </div>
        <div @click="navigateKnowledgeBase()" v-tippy="{ content: 'Knowledge Base', placement: 'bottom' }">
          <img class="header-services-icon" src="../../assets/login/landingpageTopBar/knowledge.svg" alt="pharmacy" loading="lazy" />
        </div>
        <div @click="navigateJobBoard()" v-tippy="{ content: 'Healthcare Jobs', placement: 'bottom' }">
          <img class="header-services-icon" src="../../assets/login/landingpageTopBar/job_board.svg" alt="job_board" loading="lazy" />
        </div>
        <div @click="navigateEcommerce()" v-tippy="{ content: 'E-commerce', placement: 'bottom' }">
          <img class="header-services-icon" src="../../assets/login/landingpageTopBar/shopping.svg" alt="job_board" loading="lazy" />
        </div>
      </nav>
    </div>

    <div>
      <div class="inputlogin" style="left: -13px; position: relative; top: -12px" v-if="showLoginDetails">
        <!-----------------------Company Login----------------- -->
        <div class="background_company" @click="togglecompanyLogin"
        v-tippy="{ content: 'Business Login', placement: 'bottom' }"
        style="cursor: pointer;"
         >
          B
        </div>
        <button @click="openRegistration" class="registration_btn"
          type="button">
          Register
        </button>

        <form class="login" @submit.prevent="handleSubmit" v-if="!isLoggedIn">
          <input class="searchId header-search-input" type="email" placeholder="Email" v-model="email" required />
          <div style="display: inline-block; position: relative">
            <input class="searchId header-password-input" v-model="password" :type="showPassword ? 'text' : 'password'"
              placeholder="Password" required />
            <button type="button" class="password-toggle-visibility" @click="passwordVisibility" style="
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-63%);
                background: none;
                border: none;
                cursor: pointer;
              ">
              <span v-if="showPassword"><img src="../../assets/universalProfileIcons/eye-slash-solid.svg"
                  alt="NotShowPasswordIcon" loading="lazy" height="15px" /></span>
              <span v-else><img src="../../assets/universalProfileIcons/eye-solid.svg" alt="ShowPassword" loading="lazy"
                  height="15px" /></span>
            </button>
            <span> </span>
          </div>

          <a type="button" class="forgetPassLanding" @click="toggleForgotModal">Forget Password
            <svg viewBox="0 0 24 24" height="14px" width="14px" style="position: absolute; right: -13px; top: 5px"
              fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <path d="M12 9V14" stroke="#ffde21" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                </path>
                <path
                  d="M12.0001 21.41H5.94005C2.47005 21.41 1.02005 18.93 2.70005 15.9L5.82006 10.28L8.76006 5.00003C10.5401 1.79003 13.4601 1.79003 15.2401 5.00003L18.1801 10.29L21.3001 15.91C22.9801 18.94 21.5201 21.42 18.0601 21.42H12.0001V21.41Z"
                  stroke="#ffde21" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M11.9945 17H12.0035" stroke="#ffde21" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round"></path>
              </g>
            </svg>
          </a>

          <button type="submit" :disabled="loading" class="bigSize btn-animate desktop-login-btn">
            {{ loading ? "Logging in..." : "Login" }}
          </button>
        </form>
        <button class="smallSize mobile-login-btn" id="openBtn" @click="openPopupNew">
          Login
        </button>
      </div>
      
      <!-- Hamburger Icon - Only show when NOT logged in -->
      <div class="hamburger_icon" @click="showIconsSmallDevice" v-if="!isLoggedIn">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 12H21" stroke="#6b0a23" stroke-width="2" stroke-linecap="round"/>
          <path d="M3 6H21" stroke="#6b0a23" stroke-width="2" stroke-linecap="round"/>
          <path d="M3 18H21" stroke="#6b0a23" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
    </div>

    <!-- Mobile Sidebar Overlay -->
    <div v-if="isMobileSidebarOpen" class="mobile-sidebar-overlay" @click="isMobileSidebarOpen = false"></div>

    <!-- Mobile Sidebar -->
    <div v-if="isMobileSidebarOpen" class="mobile-sidebar">
      <!-- Navigation Icons Section -->
      <div class="mobile-nav-section">
        <div class="mobile-nav-items">
          <div class="mobile-nav-item" @click="navigateBigFileShare()">
            <img class="mobile-nav-icon" src="../../assets/login/landingpageTopBar/bigFileTransfer.png" alt="bigFileTransfer" loading="lazy">
            <span class="mobile-nav-text">Big File Share</span>
          </div>
          <div class="mobile-nav-item" @click="this.$router.push('/blogs')">
            <img class="mobile-nav-icon" src="../../assets/login/landingpageTopBar/Blog.png" alt="Blog" loading="lazy" />
            <span class="mobile-nav-text">Blogs</span>
          </div>
          <div class="mobile-nav-item" @click="navigateKnowledgeBase()">
            <img class="mobile-nav-icon" src="../../assets/login/landingpageTopBar/knowledge.svg" alt="pharmacy" loading="lazy" />
            <span class="mobile-nav-text">Knowledge Base</span>
          </div>
          <div class="mobile-nav-item" @click="navigateJobBoard()">
            <img class="mobile-nav-icon" src="../../assets/login/landingpageTopBar/job_board.svg" alt="job_board" loading="lazy" />
            <span class="mobile-nav-text">Healthcare Jobs</span>
          </div>
            <div class="mobile-nav-item" @click="navigateEcommerce()">
            <img class="mobile-nav-icon" src="../../assets/login/landingpageTopBar/shopping.svg" alt="job_board" loading="lazy" />
            <span class="mobile-nav-text">E-commerce</span>
          </div>
        </div>
      </div>

      <!-- Login Buttons Section -->
      <div class="mobile-login-buttons" v-if="showLoginDetails">
        <button class="mobile-company-login-btn" @click="togglecompanyLogin">
          Business Login
        </button>
        <button class="mobile-register-btn" @click="openRegistration">
          Register
        </button>
        <button class="mobile-login-main-btn" @click="openPopupNew">
          Login
        </button>
      </div>
    </div>

    <!-- -----------------Show after click login----------------------------->
    <div v-if="isLoggedIn && paymentStatus" style="
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        place-items: center;
      " class="showAfterLogin">
      <button @click="handleShowProfile" style="border: none; outline: none; background: transparent">
        <div>
          <div class="image_container" v-if="userData" v-tippy="{
            content: 'Profile',
            placement: 'bottom',
          }" style="
              height: 45px;
              width: 45px;
              border-radius: 50%;
              box-shadow: 4px 5px 6px gray;
              padding: 4px;
            ">
            <img :src="userData.imageUrl
              ? userData.imageUrl
              : require('@/assets/profile/img/userProfile.jpg')
              " style="
                height: 100%;
                width: 100%;
                object-fit: cover;
                border-radius: 50%;
              " loading="lazy" alt="userProfile" />
          </div>
        </div>
      </button>
      <button @click="logout" style="border: none; outline: none; background: transparent">
        <div>
          <div class="image_container" v-tippy="{
            content: 'Log Out',
            placement: 'bottom',
          }" style="
              height: 35px;
              width: 35px;
              border-radius: 50%;
              box-shadow: 4px 5px 6px gray;
              padding: 4px;
            ">
            <img src="../../assets/topbar/logout.svg" alt="logout" loading="lazy" height="100%" width="100%"
              style="object-fit: cover" />
          </div>
        </div>
      </button>
    </div>

    <!-- ---------------------show after click login end---------------------------- -->
  </header>

  <div class="header-overlay" @click="$refs.menuCheckbox.checked = false"></div>

  <div v-show="companyLogin" style="z-index: 9999999">
    <company_login @close="companyLogin = false" />
  </div>

  <registration-modal
  :show="showRegistrationModal"
  @close="closeRegistrationModal"
/>

  <forgotpassword v-show="forgot" @close="toggleForgotModal" />

  <div class="popUp_overlay" @click="closePopupNEw" :style="{ display: popupVisible ? 'block' : 'none' }"></div>
  <div id="popupNEw" style="z-index: 9999999" class="popup" :style="{ display: popupVisible ? 'block' : 'none' }">
    <div class="popup-content">
      <!-- ----------------------------Forgot Password----------------------------------- -->
      <div class="loginSmallForm">
        <form class="login" @submit.prevent="handleSubmit">
          <div class="user-profile">
            <div></div>
            <i class="fa-solid fa-circle-user" style="color: #6b0a23; height: 70px"></i>
            <div></div>
          </div>
          <div class="field-of-input">
            <input type="Email" v-model="email" placeholder="" class="textbox-input" />
            <label class="form_Label-css" for=""> Email </label>
          </div>

          <div class="field-of-input" style="position: relative">
            <input :type="showPassword ? 'text' : 'password'" v-model="password" class="textbox-input" placeholder="" />
            <label class="form_Label-css" for="">Password</label>
            <button type="button" @click="passwordVisibility" style="
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                background: none;
                border: none;
                cursor: pointer;
              ">
              <span v-if="showPassword"><img src="../../assets/universalProfileIcons/eye-slash-solid.svg"
                  alt="NotShowPasswordIcon" loading="lazy" height="15px" /></span>
              <span v-else><img src="../../assets/universalProfileIcons/eye-solid.svg" alt="ShowPassword" loading="lazy"
                  height="15px" /></span>
            </button>
          </div>
          <br />
          <div class="forgetPass">
            <a type="button" @click="toggleForgotModal">Forget Password</a>
          </div>

          <button class="SuccessFullLogin">Login</button>
        </form>
      </div>
      <!-- ----------------------------Forgot Password end--------------------------------   -->
    </div>
  </div>
  <div v-if="isLoading" class="loader-overlay">
    <div class="bouncing-balls">
      <div class="ball"></div>
      <div class="ball"></div>
      <div class="ball"></div>
    </div>
  </div>
</template>

<script>
import forgotpassword from "../login/forgotpassword.vue";
import company_login from "../login/company_login.vue";
import registrationModal from "../Landing Page Middle Search/registrationModal.vue"
import { useToast } from "vue-toastification";
import axios from "axios";
import notificationService from "@/notification/services/notificationService";
const toast = useToast();
import presenceSocket, { connectPresence } from "@/services/presenceSocket";
export default {
  name: "landing_page_header",
  components: { company_login, forgotpassword, registrationModal },
  data() {
    return {
      showRegistrationModal: false,
      showPassword: false,
      isLoading: false,
      loading: false,
      email: "",
      deviceInfo: null,
deviceLocation: null,
      paymentStatus: false,
      profileCompletion: false,
      password: "",
      navMenuDisplay: "",
      showPopup: false,
      popupVisible: false,
      isLoggedIn: false,
      companyLogin: false,
      showLoginDetails: true,
      forgot: false,
      fetchdata: [],
      imageUrl: "",
      fetchdataimg: [],
      userData: null,
      isMobileSidebarOpen: false,
      previousRoute: null, // Store previous route for redirect after login
    };
  },

  computed: {
    filteredImages() {
      return this.fetchdataimg.filter(
        (image) => image.user_id === this.$store.getters.hasuserdetails._id
      );
    },
  },
  
  watch: {
    '$route'(to, from) {
      // Store previous route when it changes (only if user is not logged in)
          const isBlogPublicRoute = from.path === "/blogs" || from.path.startsWith("/blog/");
      if (!this.isLoggedIn && from.name !== null && !isBlogPublicRoute) {
        this.previousRoute = from;
        sessionStorage.setItem('previousRoute', JSON.stringify({
          path: from.path,
          name: from.name,
          params: from.params,
          query: from.query
        }));
      }
    }
  },

  created() {
    const savedUser = sessionStorage.getItem("user");
    if (savedUser) {
      const user = JSON.parse(savedUser);
      this.$store.commit("setuserDetails", user);
      this.isLoggedIn = true;
      this.showLoginDetails = false;
      this.fetchUserImage();

      if (sessionStorage.getItem("paymentStatus")) {
        this.paymentStatus = sessionStorage.getItem("paymentStatus");
      }
    }
    
    // Initialize previous route from session storage
    const savedRoute = sessionStorage.getItem('previousRoute');
    if (savedRoute) {
      this.previousRoute = JSON.parse(savedRoute);
    }
  },

  methods: {
    openRegistration() {
      this.showRegistrationModal = true;
      document.body.classList.add("no-scroll");
    },
    
    closeRegistrationModal() {
      this.showRegistrationModal = false;
      document.body.classList.remove("no-scroll");
    },
    
    showIconsSmallDevice(){
      this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
    },
    
    checkLogin(){
      const user = this.$store.getters.hasuserdetails;
      if(!user || Object.keys(user).length === 0){
        toast.warning("Please login to access this feature.");
        return false;
      }
      return true;
    },

    navigateKnowledgeBase(){
      if(!this.checkLogin()) return;
      this.$router.push('/knowledgebase');
      this.isMobileSidebarOpen = false;
    },
    
    navigateBigFileShare(){
      if(!this.checkLogin()) return;
      this.$router.push('/large-file-upload');
      this.isMobileSidebarOpen = false;
    },
    
    navigateJobBoard(){
      if(!this.checkLogin()) return;
      this.$router.push('/showJobsPage');
      this.isMobileSidebarOpen = false;
    },
    navigateEcommerce() {
      if (!this.checkLogin()) return;
      this.$router.push('/homeEcommerce');
      this.isMobileSidebarOpen = false;
    },
    
    passwordVisibility() {
      this.showPassword = !this.showPassword;
    },
    
    selectedIcon(icon) {
      this.$emit("updateIcon", icon);
    },
    
    async logout() {
      try {
        // Store current route before logging out
        this.previousRoute = this.$route;
        sessionStorage.setItem('previousRoute', JSON.stringify({
          path: this.$route.path,
          name: this.$route.name,
          params: this.$route.params,
          query: this.$route.query
        }));
        
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}auth/logout`,
          {
            withCredentials: true,
          }
        );
        if (response.data.success) {
          presenceSocket.disconnect();
          this.$store.dispatch("logout");
          await this.$router.push({ path: "/" });
          toast.clear();
          toast.success(response.data.message);
          this.isLoggedIn = false;
          this.showLoginDetails = true;
          this.isMobileSidebarOpen = false;
        }
      } catch (error) {
        toast.success(
          error.response.data.message || error.message || "Failed to logout.."
        );
      }
    },
    
    togglecompanyLogin() {
      this.companyLogin = !this.companyLogin;
      document.body.classList.add("no-scroll");
      this.isMobileSidebarOpen = false;
    },
    
    toggleForgotModal() {
      this.forgot = !this.forgot;
      this.closePopupNEw();
      if (this.forgot) document.body.classList.add("no-scroll");
      else document.body.classList.remove("no-scroll");
      this.isMobileSidebarOpen = false;
    },
    
    openPopup() {
      var popup = document.getElementById("popup");
      if (popup.style.display === "none" || popup.style.display === "") {
        popup.style.display = "block";
        document.body.classList.add("popup-open");
        document.body.classList.add("no-scroll");
      } else {
        popup.style.display = "none";
        document.body.classList.remove("popup-open");
        document.body.classList.remove("no-scroll");
      }
      this.isMobileSidebarOpen = false;
    },
    
    openPopupNew() {
      this.popupVisible = true;
      document.body.classList.add("no-scroll");
      this.isMobileSidebarOpen = false;
    },
    
    closePopupNEw() {
      this.popupVisible = false;
      document.body.classList.remove("no-scroll");
    },
    
    openPopup1() {
      this.showPopup = true;
    },
    
    closePopup() {
      this.showPopup = false;
    },

    redirectToNextPage() {
      this.$router.push("/file_uploads");
    },
    
    toggleNavMenu() {
      this.navMenuDisplay = this.navMenuDisplay === "flex" ? "none" : "flex";
    },

    // fetch userImage
    async fetchUserImage() {
      try {
        const user_id = this.$store.getters.hasuserdetails._id;
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}auth/getimage/${user_id}`,
          { withCredentials: true }
        );
        this.userData = response.data;
      } catch (err) {
        console.log("Error to fetch image", err);
      }
    },

    async handleSubmit() {
      if (this.loading) return;
      this.loading = true;
      this.isLoading = true; // Show bounce animation

      try {
        const { deviceInfo, deviceLocation } =
  await notificationService.getDeviceInfoAndLocation();

this.deviceInfo = deviceInfo;
this.deviceLocation = deviceLocation;
        const response = await axios.post(`${process.env.VUE_APP_BASE_URL}auth/login`, {
          email: this.email,
          password: this.password,
         deviceInfo: JSON.stringify(this.deviceInfo),
deviceLocation: JSON.stringify(this.deviceLocation),
        }, { withCredentials: true });

        const data = response.data;
        this.paymentStatus = data.user.payment_status;
        this.profileCompletion = data.user.profile_completion;
        
        // Set user role and fetch permissions
        sessionStorage.setItem("user", JSON.stringify(data.user));
        this.$store.commit("setuserDetails", data.user);
        this.$store.dispatch("setUserRoleAndFetchPermissions", data.user.role);

        // Save user data
        delete data.user.password;
        delete data.user.__v;
        localStorage.setItem("user", JSON.stringify(data.user));
        sessionStorage.setItem("user", JSON.stringify(data.user));
        localStorage.setItem("token", data.auth);
        sessionStorage.setItem("token", data.auth);
        localStorage.setItem("paymentStatus", this.paymentStatus);
        sessionStorage.setItem("paymentStatus", this.paymentStatus);
        localStorage.setItem("isFirstLogin", data.user.firstLoginCompleted);
        sessionStorage.setItem("isFirstLogin", data.user.firstLoginCompleted);

        this.$store.commit("setuserDetails", data.user);
        this.isLoggedIn = true;
        this.showLoginDetails = false;
        this.fetchUserImage();
        this.popupVisible = false;
        this.isMobileSidebarOpen = false;
        connectPresence(); 
        toast.clear();
        toast.success("Login successful.");

        // Check if payment is required or profile needs completion
        if (!this.paymentStatus) {
          this.$router.push({ path: "/membership-plans" });
        } else if (this.paymentStatus && !this.profileCompletion && data.user.role === "doctor") {
          this.$router.push({ path: "/doctor-profile-completion" });
        } else {
          // Redirect logic after successful login
          await this.handlePostLoginRedirect(data.user);
        }

      } catch (error) {
        console.error("Login error:", error);
        toast.clear();
        toast.error(error.response?.data?.message || "An error occurred. Please try again.");
      } finally {
        this.loading = false;
        this.isLoading = false; // Hide bounce animation
      }
    },

    // async handlePostLoginRedirect(user) {
    //   // If it's first login, redirect to profile
    //   if (!user.firstLoginCompleted) {
    //     await this.handleShowProfile();
    //   } else {
    //     // For subsequent logins, check if we have a previous route to redirect back to
    //     const savedRoute = sessionStorage.getItem('previousRoute');
        
    //     if (savedRoute) {
    //       const previousRoute = JSON.parse(savedRoute);
          
    //       // Don't redirect back to login page or home if user was trying to access a specific page
    //       if (previousRoute.name && previousRoute.name !== 'login' && previousRoute.path !== '/') {
    //         try {
    //           await this.$router.push({
    //             path: previousRoute.path,
    //             query: previousRoute.query,
    //             params: previousRoute.params
    //           });
    //           // Clear the stored route after successful redirect
    //           sessionStorage.removeItem('previousRoute');
    //           return;
    //         } catch (navigationError) {
    //           console.warn('Navigation to previous route failed, falling back to profile', navigationError);
    //           // Fall back to profile if navigation fails
    //           await this.handleShowProfile();
    //         }
    //       } else {
    //         // No meaningful previous route, go to profile
    //         await this.handleShowProfile();
    //       }
    //     } else {
    //       // No stored route, go to profile
    //       await this.handleShowProfile();
    //     }
    //   }
    // },

    // async handleShowProfile() {
    //   const user = this.$store.getters.hasuserdetails;

    //   if (!user) {
    //     await this.$store.dispatch("logout");
    //     toast.error("User not found. Please login again.");
    //     return;
    //   }

    //   this.isLoading = true; 

    //   try {
    //     if (!user.firstLoginCompleted) {
    //       await axios.put(
    //         `${process.env.VUE_APP_BASE_URL}auth/update-first-login`,
    //         { userId: user._id },
    //         { withCredentials: true }
    //       );
    //       user.firstLoginCompleted = true;
    //       const updatedUser = { ...user, firstLoginCompleted: true };
    //       this.$store.commit("setuserDetails", updatedUser);
    //       localStorage.setItem("user", JSON.stringify(updatedUser));
    //       sessionStorage.setItem("user", JSON.stringify(updatedUser));
    //     }

    //     await new Promise((resolve) => setTimeout(resolve, 500));

    //     await this.$router.push(`/${user.role}`);
    //   } catch (error) {
    //     console.error("Error updating first login status:", error);
    //     toast.error("Something went wrong. Please try again.");
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },



    async handlePostLoginRedirect(user) {
  try {
    // If it's first login, redirect to profile flow
    if (!user.firstLoginCompleted) {
      await this.handleShowProfile();
      return;
    }

    // =========================
    // Get saved route safely
    // =========================
    let previousRoute = null;

    const savedRoute = sessionStorage.getItem("previousRoute");

    if (savedRoute) {
      try {
        previousRoute = JSON.parse(savedRoute);
      } catch (e) {
        console.warn("Invalid previousRoute JSON:", e);
        sessionStorage.removeItem("previousRoute");
      }
    }

    // =========================
    // Redirect logic
    // =========================
    if (
      previousRoute &&
      previousRoute.name &&
      previousRoute.name !== "login" &&
      previousRoute.path !== "/" &&
      previousRoute.path !== "/blogs" &&
      !previousRoute.path.startsWith("/blog/")
    ) {
      try {
        await this.$router.push({
          path: previousRoute.path,
          query: previousRoute.query || {}
        });

        sessionStorage.removeItem("previousRoute");
        return;
      } catch (err) {
        console.warn(
          "Navigation to previous route failed. Falling back to profile",
          err
        );
        await this.handleShowProfile();
        return;
      }
    }

    // fallback
    await this.handleShowProfile();
  } catch (error) {
    console.error("handlePostLoginRedirect error:", error);
    await this.handleShowProfile();
  }
},
async handleShowProfile() {
  const user = this.$store.getters.hasuserdetails;

  if (!user) {
    await this.$store.dispatch("logout");
    toast.error("User not found. Please login again.");
    return;
  }

  this.isLoading = true;

  try {
    // =========================
    // First login update
    // =========================
    if (!user.firstLoginCompleted) {
      await axios.put(
        `${process.env.VUE_APP_BASE_URL}auth/update-first-login`,
        { userId: user._id },
        { withCredentials: true }
      );

      // ❌ DO NOT mutate Vuex object directly
      const updatedUser = {
        ...user,
        firstLoginCompleted: true
      };

      this.$store.commit("setuserDetails", updatedUser);

      localStorage.setItem("user", JSON.stringify(updatedUser));
      sessionStorage.setItem("user", JSON.stringify(updatedUser));
    }

    // small UX delay (optional)
    await new Promise((resolve) => setTimeout(resolve, 300));

    // =========================
    // SAFE navigation
    // =========================
    const targetRoute = `/${user.role}`;

    if (this.$route.path !== targetRoute) {
      await this.$router.push(targetRoute);
    }

  } catch (error) {
    console.error("Error updating first login status:", error);
    toast.error("Something went wrong. Please try again.");
  } finally {
    this.isLoading = false;
  }
}
  },
};
</script>

<style scoped>
@import url(./landing_page_header.css);

.header-services-icon{
    width: 1.8rem;
    position: relative;
    top: 2.9px;
    margin: 0px 18px;
    cursor: pointer;
}
.logo-container {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 0;
  cursor: pointer;
}

.logo-image {
  height: 45px;
  width: 45px;
  object-fit: contain;
}

.logo-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1;
  margin: 0;
  padding: 0;
}

.logo-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #6b0a23;
  margin: 0;
  padding: 0;
  line-height: 1.1;
  letter-spacing: 0.5px;
}

.logo-subtitle {
  font-size: 0.7rem;
  color: #8b1a38;
  margin: 0;
  padding: 0;
  line-height: 1.1;
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* Header Styles */
.landing-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem 1.5rem;
  background: linear-gradient(
    66deg,
    rgb(183 233 247) 25%,
    rgb(255 255 255) 100%
  );
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed !important;
  top: 0px !important;
  z-index: 9999 !important;
  width: 100%;
}

.hamburger_icon{
  display: none;
}

/* Mobile Sidebar Styles */
@media (max-width: 768px) {
  .hamburger_icon{
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0.5rem;
    z-index: 1001;
  }
  
  .icons_div_s-01{
    display: none !important;
  }
  
  .inputlogin{
    display: none !important;
  }
  
  /* Mobile Sidebar Overlay */
  .mobile-sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
  
  /* Mobile Sidebar */
  .mobile-sidebar {
    position: fixed;
    top: 1px;
    right: 0;
    width: 280px;
    height: 100vh;
    background: white;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    padding: 0rem 1rem;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  
  /* Mobile Navigation Section */
  .mobile-nav-section {
    padding: 0;
  }
  
  .mobile-nav-items {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .mobile-nav-item {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.8rem;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .mobile-nav-item:hover {
    background-color: #f5f5f5;
  }
  
  .mobile-nav-icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
  
  .mobile-nav-text {
    font-size: 1rem;
    color: #333;
    font-weight: 500;
  }
  
  /* Mobile Login Buttons Section */
  .mobile-login-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0;
  }
  
  .mobile-company-login-btn {
    width: 100%;
    padding: 0.8rem 1rem;
    color:  #6b0a23;
    border: 1px solid  #6b0a23;
    border-radius: 50px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.9rem;
  }
  
  .mobile-register-btn {
    width: 100%;
    padding: 0.8rem 1rem;
    background-color: transparent;
    color: #ffde21;
    border: 1px solid #ffde21;
    border-radius: 50px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.9rem;
  }
  
  .mobile-login-main-btn {
    width: 100%;
    padding: 0.8rem 1rem;
    background: #6b0a23;
    color: white;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    font-weight: 500;
    font-size: 0.9rem;
  }

  .logo-container {
    gap: 6px;
  }
  
  .logo-image {
    height: 40px;
    width: 40px;
  }
  
  .logo-title {
    font-size: 1.1rem;
  }
  
  .logo-subtitle {
    font-size: 0.65rem;
  }
  
  .landing-page-header {
    padding: 0.2rem 0.2rem;
  }
}

@media (max-width: 480px) {
  .mobile-sidebar {
    width: 260px;
  }
  
  .logo-container {
    gap: 5px;
  }
 
  .logo-image {
    height: 42px;
    width: 42px;
  }
  
  .logo-title {
    font-size: 1rem;
  }
  
  .logo-subtitle {
    font-size: 0.6rem;
  }
}

.arrow {
  margin-left: 9px;
  margin-top: 4px;
  color: #eee;
  font-size: 10px;
}

.logout_profile {
  cursor: pointer;
}

/* Enhanced Bounce Animation Styles */
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  backdrop-filter: blur(2px);
}

.bouncing-balls {
  display: flex;
  align-items: center;
  height: 60px;
  gap: 8px;
}

.ball {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #6b0a23;
  animation: bounce 0.8s infinite alternate;
  box-shadow: 0 2px 8px rgba(107, 10, 35, 0.3);
}

.ball:nth-child(1) {
  background-color: #6b0a23;
}

.ball:nth-child(2) {
  background-color: #8b1a38;
  animation-delay: 0.2s;
}

.ball:nth-child(3) {
  background-color: #ab2a4c;
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0) scale(1);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-25px) scale(1.1);
    opacity: 1;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 0.7;
  }
}

/* Additional animation for the container */
.bouncing-balls {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}
</style>